import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceUnavailabilityCreationNotificationState = createStateReducer(
  initialState,
  {
    [events.createUnavailabilitySucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createUnavailability",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createUnavailabilityFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createUnavailability",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceUnavailabilityCreationNotificationState };
